module.exports = __webpack_public_path__ + "img/4.6b1783b0.jpg";